import * as React from 'react';
import './loadMoreButton.module.scss';
import { LoaderRow } from '../../../../mainv3/components/atoms/layout/LoaderRow';
import { Button } from './Button';

export const LoadMoreButton = ({ loading, fetchNextPage }) => {
    if (loading) {
        return <LoaderRow />;
    }

    return (
        <div styleName="load-more-button-wrapper">
            <Button type="primary" onClick={fetchNextPage} className="load-more-button">
                続きを見る
            </Button>
        </div>
    );
};
